/* eslint-disable  @typescript-eslint/no-explicit-any */
import { useCallback, useRef } from 'react';

export const useDebounce = (callback: any, delay: number) => {
  const timer: any = useRef(null);

  return useCallback(
    (...args) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );
};
